import axios from '@/api/axios'

export default {
    /* 企业用户登录 第一步 */

    companyLogin: (params) => axios.post('/b/company/saas/account/login', params),

    /* 企业用户登录 第二步 */

    selectCompanyLogin: (params) => axios.post('/b/company/saas/account/selectCompanyLogin', params),

    /* 获取验证码 (无权限) */

    getValidateCodeNotAuth: (params) => axios.post('/b/base/v1/sms/captcha/send', params),

    /* 获取验证码 (有权限) */

    getValidateCodeAuth: (params) => axios.post('/b/base/v1/sms/captcha/send:auth', params),

    /* 企业用户信息 */

    getProfile: (params) => axios.get('/b/company/saas/companyStaff/profile', { params }),

    /* 修改密码 */
    changePassword: (params) => axios.post('/b/company/saas/account/changePassword', params),

    /* 职位 */
    /* 企业职位列表  */

    getPositionList: (params) => axios.get('/b/company/saas/job/list', { params }),

    /* 发布agent职位  */

    createAgentPosition: (params) => axios.post('/b/company/saas/job/publishAgent', params),

    /* 发布蓝领职位  */

    createBluePosition: (params) => axios.post('/b/company/saas/job/publishBlue', params),

    /* 企业职位列表 (下拉列表) */

    getPositionListForSelect: (params) => axios.get('/b/company/v1/job/listForSelect', { params }),

    /* 企业获取福利 和 入职资料    tag_type  1=企业福利 2=企业入职资料 */

    getCompanyBenefitsAndEntryInfo: (params) => axios.get('/b/base/v1/tag/list', { params }),

    /* 生成职位描述 */

    getJobDescription: (params) => axios.post('/b/goai/v1/openai/jobDescription', { params }),

    /* 职位 发布和下线 */

    releaseOrOfflinePosition: (params) => axios.post('/b/company/saas/job/release', params),

    /* 职位删除 */

    deletePosition: (params) => axios.post('/b/company/saas/job/delete', params),

    /* 职位邀请 */

    invitePosition: (params) => axios.post('/b/company/saas/job/agent/updateInvitation', params),

    /* 获取职位邀请详情 */

    getPositionResult: (params) => axios.get('/b/company/saas/job/get', { params }),

    /* 获取面试记录列表 */

    getAgentMatchRecord: (params) => axios.get('/b/interview/saas/agentMatchRecord/list', { params }),

    /* 获取用户简历详情 */

    getTalentResume: (params) => axios.post('/b/resume/v1/resume/detail', params),

    // 面试报告
    getInterviewAiReport: (params) => axios.get('/b/interview/v1/aiReport', { params }),

    /* 权益 */
    /* 创建权益点套餐 */

    getRightsMenu: (params) => axios.get('/b/order/saas/rights/menu', { params }),

    /* 创建权益点套餐 */
    createOrder: (params) => axios.post('/b/order/saas/order', params),

    /* 获取订单列表 */

    getOrdersList: (params) => axios.get('/b/order/saas/orders', { params }),

    /* 获取支付宝支付二维码 */

    getAlipayQr: (params) => axios.get('/b/order/saas/alipay/qr', { params }),

    /* 获取微信支付二维码 */

    getWechatQr: (params) => axios.get('/b/order/saas/wechat/qr', { params }),

    /* 获取订单详情 */

    pollPayResult: (params) => axios.get(`/b/order/saas/order/${params.order_no}`, { params }),

    /* 删除订单 */
    deleteOrder: (params) => axios.delete(`/b/order/saas/order/${params.order_no}`),

    /* 检查是否可以领取体验套餐 */
    checkExperienceEnabled: (params) => axios.get(`/b/order/saas/experience/enabled`, { params }),

    /* 获取体验套餐 */
    getExperienceMenu: (params) => axios.get(`/b/order/saas/experience/menu`, { params }),

    /* 免费领取套餐 */
    createFreeMenu: (params) => axios.post('/b/order/saas/experience/create', params),

    /* 企业抬头税号信息 */
    getCompanyTax: (params) => axios.get(`/b/company/v1/companyTax/info`, { params }),

    /* 开具发票 */
    createInvoicePPP: (data) => axios.post('/b/order/saas/order/invoice', data),

    /* 检查权限点剩余次数 */
    getCheckRights: (params) => axios.post(`/b/order/saas/order/rights/check`, params),
    /* 下拉职位列表 */
    getPositionListBySelect: (params) => axios.get(`/b/company/saas/job/listForSelect`, { params }),

    /* 检查职位名称是否重复 */
    checkPositionName: (params) => axios.get(`/b/company/saas/job/checkName`, { params }),

    /* 获取im服务初始化信息 */
    IMServiceInitB: (data) => axios.post('/b/base/v1/self_service/init', data),

    // 获取B端客服im 账号
    getImUserSig: (params) => axios.get('/b/base/v1/customerServer/get', { params }),

    // 保存im聊天信息
    saveChatImToB: (params) => axios.post('/b/interview/saas/chat/im', params),

    // 修改订单邀请码
    updateOrderInvitationCode: (order_no, params) => axios.put(`/b/order/v1/order/${order_no}`, params),

    //  消费权益记录
    getConsumptionList: (params) => axios.get(`/b/order/saas/rights/used/details`, { params }),

    //  职位列表
    getjobList: (params) => axios.get(`/b/company/saas/job/list/all`, { params }),

    //  邀请码生成记录列表
    getInvitationCodeList: (params) => axios.get(`/b/company/saas/job/invitationCodeGenLog/list`, { params }),

    //扫码记录生成列表
    getScanCodeList: (params) => axios.get(`/b/company/saas/job/scanLog/list`, { params }),

    //获取汇款信息(对公转账)
    getRemittanceInfo: (params) => axios.get(`/b/order/saas/order/remittance/info`, {params}),


    /* 注册企业 */
    companyRegister: (params) => axios.post('/b/company/saas/company/register/two', params),

    /* B端新手引导状态修改*/ 
    newbieGuideUpdateB: (params) => axios.post('/b/company/v1/welcome/set', params),
    /* 获取B端新手引导状态 */
    getnewbieGuideTypB: (params) => axios.post('/b/company/v1/welcome/status',params),
}
